import React, { FunctionComponent } from "react";
import { useWhiteLabelSetting } from "components/WhiteLabelProvider";
import {Trans} from "@lingui/macro";
import {AJR, IJR} from "../../../settings";

export interface Props {}

export const Disclaimer: FunctionComponent<Props> = () => {
  const disclaimer = useWhiteLabelSetting("disclaimer");
  return (
    <div className="disclaimer">
      <div>TAXPLANNER (Versie:{process.env.REACT_APP_SOFISK_VERSION_NUMBER})</div>
      <div><Trans>AANSLAGJAAR {AJR}</Trans></div>
      <div><Trans>INKOMSTEN VAN {IJR}</Trans></div>
      <div style={{ marginTop: "1em" }}>{disclaimer}</div>
    </div>
  );
};

Disclaimer.displayName = "Disclaimer";
